export default __webpack_public_path__ + "static/media/OMSC_04.939936c8.gif";